import { createUseStyles, ComposedTheme } from '@glu/theming';

const styles = ({ palette: { grey }, spacing: { unit }, typography }: ComposedTheme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    background: grey.G100,
    padding: 1.25 * unit,
    borderRadius: 0.375 * unit,
    maxWidth: '100%'
  },
  dt: {
    flexBasis: '30%',
    fontSize: typography.fontSize,
    fontWeight: typography.fontWeightHeavy,
    marginBottom: '0.5rem',
    maxWidth: '30%',
    textAlign: 'left'
  },
  dd: {
    flexBasis: '70%',
    fontSize: typography.fontSize,
    margin: '0 0 0.5rem 0',
    wordBreak: 'break-word'
  }
});

export default createUseStyles(styles);
